import { AllTrailTraffic, VisitorUsage } from '../types/TrailTraffic';

const trailTrafficToVisitorUsage: Record<AllTrailTraffic, VisitorUsage> = {
  light: 1,
  moderate: 2,
  heavy: 3,
  'extra-heavy': 4
};

export default trailTrafficToVisitorUsage;
